import { restApiRP } from "@plannel/services/utils/rest-api";

const rpSummaries = params => {
  return restApiRP.get("/api/rp-comp/rp-summaries", { params });
};

const release = data => {
  return restApiRP.post("/api/rp-comp/release-version", data);
}

const rpCompService = {
  rpSummaries,
  release
};

export default rpCompService;